export default "__VITE_ASSET__BgNFmRWC__"